import typography from '../typography';
export default {
  root: {
    fontSize: typography.body2.fontSize,
  },
};
